import { showModal } from 'ducks/modal';
import { removeLessonEntryAction, updateDrivingLessonEntryAction, updateLessonEntriesList, updateLessonEntryAction } from 'ducks/workItem';
import { isFunction } from 'lodash-es';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import * as Table from 'reactabular-table';
import { Flex, Text } from 'rebass';
import { bindActionCreators } from 'redux';
import * as sort from 'sortabular';
import { PvBadgePurple, PvCaret, PvCheck } from 'styles/CustomComponents';
import * as resolve from 'table-resolver';
import { formatCourseCompact } from '../../util/FormatUtil';
import { LessonTypeIcon, PvEditIcon } from '../../util/IconUtil';
import Spinner from '../Spinner';


class LessonEntryDataTable extends React.Component {
  constructor(props) {
    super(props);
    const getSortingColumns = () => this.state.sortingColumns || {};

    const updateLessonEntry = (lessonEntry) => {
      this.props.updateLessonEntry(lessonEntry, this.props.rows, this.props.applicantId);
    };

    const removeLessonEntry = (applicantId, lessonEntryId) => {
      this.props.removeLessonEntry(applicantId, lessonEntryId, this.props.rows);
    };

    const updateDrivingLessonEntry = (lessonEntry) => {
      this.props.updateDrivingLessonEntry(lessonEntry, this.props.rows);
    };

    this.updateLessonEntry = updateLessonEntry.bind(this);
    this.removeLessonEntry = removeLessonEntry.bind(this);
    this.updateDrivingLessonEntry = updateDrivingLessonEntry.bind(this);

    const showEditLessonEntryModal = (props) => {
      if (~props.rowData.lesson.lessonType.indexOf('THEORY') || ~props.rowData.lesson.lessonType.indexOf('TRAINING')) {
        const modalProps = {
          applicantNameAndTrafiId: this.props.applicantNameAndTrafiId,
          lessonEntry: props.rowData,
          saveFn: this.updateLessonEntry,
          removeFn: this.removeLessonEntry,
          examClasses: this.props.activeExamClasses,
          lessons: this.props.activeLessons,
          applicantId: this.props.applicantId,
          loadingEntryAction: this.props.loadingEntryAction,
          error: this.props.entryError
        };
        
        this.props.showEditTheorylessonEntryModal(modalProps);
      } else {
        const modalProps = {
          applicantNameAndTrafiId: this.props.applicantNameAndTrafiId,
          lessonEntry: props.rowData,
          saveFn: this.updateDrivingLessonEntry,
          removeFn: this.removeLessonEntry,
          applicantId: this.props.applicantId,
          loadingEntryAction: this.props.loadingEntryAction,
          error: this.props.entryError,
          examClasses: this.props.activeExamClasses,
          lessons: this.props.activeLessons,
        };

        this.props.showEditDrivinglessonEntryModal(modalProps);
      }
    };

    const sortable = sort.sort({
      getSortingColumns,
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumn({
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      },
      strategy: sort.strategies.byProperty
    });

    const columns = [
      {
        property: 'lesson.lessonType',
        header: {
          label: <Flex alignItems='center' justifyContent='space-between'><Translate
            value='datatable.lesson_type' /><PvCaret /></Flex>,
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty
            })
          ]
        },
        props: {
          style: {
            width: '5em',
            textAlign: 'center'
          }
        },
        cell: {
          formatters: [
            (value) => <LessonTypeIcon type={value} />
          ]
        },
        visible: true,
      },
      {
        property: 'lesson.description',
        header: {
          label: <Flex alignItems='center' justifyContent='space-between'><Translate
            value='datatable.topic' /><PvCaret /></Flex>,
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty
            })
          ]
        },
        visible: true,
      },
      {
        property: 'lessonEndTime',
        header: {
          label: <Flex alignItems='center' justifyContent='space-between'><Translate
            value='datatable.completed' /><PvCaret /></Flex>,
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty
            })
          ]
        },
        props: {
          style: {
            width: '8em'
          }
        },
        cell: {
          formatters: [
            (value, props) => {
              if (props.rowData.lessonStatus === 'COMPENSATED')
                return <PvBadgePurple title={props.rowData.additionalInfo}><Translate value='datatable.compensated' /></PvBadgePurple>;
              if (props.rowData.lessonStatus === 'UNDONE')
                return <PvBadgePurple><Translate value='datatable.undone' /></PvBadgePurple>;
              else
                return moment.unix(value / 1000).format('L'); // HOX: division by 1000
            }
          ]
        },
        visible: true,
      },
      {
        property: 'course',
        header: {
          label: <Translate value='datatable.additional_info' />,
        },
        props: {
          style: {
            width: '12em'
          }
        },
        cell: {
          formatters: [
            (course, props) => {
              const additionalInfo = [];
              if(props.rowData.additionalInfo) {
                additionalInfo.push(props.rowData.additionalInfo);
              }
              additionalInfo.push(formatCourseCompact(course, true));
              
              return additionalInfo.join(', ')
            }
          ]
        },
        visible: true,
      },
      {
        property: 'lesson.requiredForIndependentTraining',
        header: {
          label: <Translate value='datatable.independent_training' />,
        },
        props: {
          style: {
            textAlign: 'center',
            width: '9em'
          }
        },
        cell: {
          formatters: [
            isTrue => isTrue && <Text textAlign='center'><PvCheck /></Text>
          ]
        },
        visible: props => props.showProColumns,
      },
      {
        property: 'lesson.requiredForPersonTransport',
        header: {
          label: <Translate value='datatable.person_transport' />,
        },
        props: {
          style: {
            textAlign: 'center',
            width: '12em'
          }
        },
        cell: {
          formatters: [
            isTrue => isTrue && <Text textAlign='center'><PvCheck /></Text>
          ]
        },
        visible: props => props.showProColumns,
      },
      {
        props: {
          style: {
            textAlign: 'center',
            width: '2em'
          }
        },
        cell: {
          formatters: [
            (value, props) => this.props.isTeacher && <PvEditIcon onClick={() => showEditLessonEntryModal(props)} />
          ]
        },
        visible: this.props.isTeacher,
      },
    ];

    this.state = {
      // Default sorting
      sortingColumns: {
        'lessonEndTime': {
          direction: 'desc',
          position: 0
        },
      },
      columns,
      rows: resolve.resolve(
        {
          columns,
          method: resolve.nested
        }
      )(this.props.rows || [])
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      rows: resolve.resolve(
        {
          columns: this.state.columns,
          method: resolve.nested
        }
      )(props.rows || [])
    });
  }

  render() {
    const {
      stylingRenderers,
      rowKey,
    } = this.props;
    
    const { sortingColumns, columns, rows } = this.state;
    const visibleCols = columns.filter(column => isFunction(column.visible) ? column.visible(this.props) : column.visible );
    const finalRows =
    sort.sorter({
      columns: visibleCols,
      sortingColumns,
      sort: orderBy,
      strategy: sort.strategies.byProperty
    })(rows);
   
    return (
      <React.Fragment>
        {this.props.loadingEntryAction && <Spinner />}
        <Table.Provider
          renderers={stylingRenderers}
          columns={visibleCols}>
          <Table.Header />
          <Table.Body rows={finalRows} rowKey={rowKey || 'entityId'} />
        </Table.Provider>
      </React.Fragment>
    );
  }
}

LessonEntryDataTable.propTypes = {
  applicantNameAndTrafiId: PropTypes.string,
  activeLessons: PropTypes.array,
  activeExamClasses: PropTypes.array,
  isTeacher: PropTypes.bool,
  rows: PropTypes.array,
  columns: PropTypes.array,
  stylingRenderers: PropTypes.object,
  rowKey: PropTypes.string,
  showEditTheorylessonEntryModal: PropTypes.func,
  showEditDrivinglessonEntryModal: PropTypes.func,
  removeLessonEntry: PropTypes.func,
  updateLessonEntriesList: PropTypes.func,
  updateLessonEntry: PropTypes.func,
  showProColumns: PropTypes.bool
};

const mapStateToProps = (state) => {
  return {
    applicantId: state.workItem.selectedApplicant.applicant.entityId,
    loadingEntryAction: state.workItem.lessonEntry.loading,
    entryError: state.workItem.lessonEntry.error,
    currentCourse: state.userState.currentCourse,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  showEditTheorylessonEntryModal: (modalProps) => showModal('EDIT_THEORYLESSON_ENTRY', modalProps),
  showEditDrivinglessonEntryModal: (modalProps) => showModal('EDIT_DRIVINGLESSON_ENTRY', modalProps),
  removeLessonEntry: (applicantId, lessonEntryId, originalEntries) => removeLessonEntryAction(applicantId, lessonEntryId, originalEntries),
  updateLessonEntriesList: (lessonEntries) => updateLessonEntriesList(lessonEntries),
  updateLessonEntry: (lessonEntry, originalEntries, applicantId) => updateLessonEntryAction(lessonEntry, originalEntries, applicantId),
  updateDrivingLessonEntry: (lessonEntry, originalEntries) => updateDrivingLessonEntryAction(lessonEntry, originalEntries)
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LessonEntryDataTable);


// WEBPACK FOOTER //
// ./src/components/datatable/LessonEntryDataTable.jsx